import React from 'react';
import styled, { css } from 'styled-components';

import {
  paragraphXSmallSize,
  paragraphXSmallLineHeight,
} from '../../constants/text';

export const paragraphXSmallStyle = css`
  font-size: ${paragraphXSmallSize};
  line-height: ${paragraphXSmallLineHeight};
  font-weight: 400;
`;

export const StyledParagraphXSmall = styled.p`
  ${paragraphXSmallStyle}
`;

export const ParagraphXSmall = (props) => {
  const { children } = props;

  return <StyledParagraphXSmall {...props}>{children}</StyledParagraphXSmall>;
};
